import { preventMinification } from './preventMinification';
import { useUserStore } from '@/stores/userStore';

/**
 * Retrieves the API key for Faro analytics.
 * Logic:
 *   1. If VITE_FARO_USER_AUTH_ENABLE is true, use user access token.
 *   2. Otherwise, generate and return a UUID.
 */
export async function getFaroApiKey(): Promise<string> {
  const userAuthEnabled =
    preventMinification(import.meta.env.VITE_FARO_USER_AUTH_ENABLE) === 'true';

  if (userAuthEnabled) {
    const user = useUserStore();
    if (!user.user) {
      await user.fetch();
    }
    return user.user?.access_token || '';
  }

  return crypto.randomUUID();
}
